import { memo, useEffect, useState } from 'react';
import type { JSX } from 'react';
import { Navigate } from 'react-router-dom';

import useAuthStore from '~/stores/auth/useAuthStore';
import { useTokenStore } from '~/stores/token/useTokenStore';

type IPublicRouteProps = {
  children: React.ReactNode;
};

const checkAuth = async (): Promise<boolean> => {
  const hasBaseTokens =
    Boolean(useTokenStore.getAccess()) &&
    Boolean(useTokenStore.getRefresh()) &&
    Boolean(useTokenStore.getScope());

  if (!hasBaseTokens) return false;

  // valida/renova se necessário (sem logout)
  await useAuthStore.getState().authTokenSlice.ensureValidToken(undefined);

  // se ainda tem access após ensure => autenticado
  return Boolean(useTokenStore.getAccess());
};

function PublicRoute({ children }: IPublicRouteProps): JSX.Element {
  const [isAuth, setIsAuth] = useState<boolean | null>(null);

  useEffect(() => {
    let alive = true;

    (async () => {
      try {
        const ok = await checkAuth();
        if (alive) setIsAuth(ok);
      } catch {
        if (alive) setIsAuth(false);
      }
    })();

    return () => {
      alive = false;
    };
  }, []);

  if (isAuth === null) return <div>Carregando...</div>;

  return isAuth ? <Navigate to="/apps" replace /> : (children as JSX.Element);
}

export default memo(PublicRoute);
